import { render, staticRenderFns } from "./VcodeButton.vue?vue&type=template&id=2ca71202&scoped=true&"
import script from "./VcodeButton.vue?vue&type=script&lang=js&"
export * from "./VcodeButton.vue?vue&type=script&lang=js&"
import style0 from "./VcodeButton.vue?vue&type=style&index=0&id=2ca71202&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca71202",
  null
  
)

export default component.exports